import { SiteAuditInformation } from '@models/interfaces';

export const SITE_AUDIT_MOMENTIZE_FIELDS: Array<
  keyof Omit<SiteAuditInformation, 'raycaps' | 'cables' | 'siteAuditNote'>
> = ['scheduledSiteWalkDate', 'siteWalkCompleteDate', 'savedToFileDate'];
